/**
 * @classdesc
 * Digitalisierungs-Modul-Zeichnen-Panel.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.module Modul-Instanz
 */
gc.gis.module.GCDigitize.DrawPanel = function(options)
{
	gc.gis.assert.isSet(options);
	gc.gis.assert.isInstance(options.module, gc.gis.module.GCDigitize);

	/**
	 * @type {gc.gis.module.GCDigitize}
	 * @private
	 */
	this._module = options.module;

	var options_widget = {
		className: 'gc-digitize-panel-draw'
	};

	gc.gis.widget.GCPanel.call(this, options_widget);

	this._render();
	this._initContent();
};
gc.gis.module.GCDigitize.DrawPanel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCDigitize.DrawPanel.prototype._initContent = function()
{
	var self = this;

	// Panel Inhalt
	var controls = [];

	// Fangfunktion
	var snapCtrl = this._module.map.getSnapControl();
	if (snapCtrl)
	{
		controls = controls.concat(snapCtrl.getFormConfig());
	}

	// TODO einelne Funktionen wieder einblenden und implementieren zz. nur für Releaseversion auskommentiert
	// Force-Center
	//  controls[controls.length] = {
	// 	label: 'Mittelpunkt fixieren',
	// 	name: 'digitize_forcecenter',
	// 	tooltip: 'Fixiert den Mittelpunkt während des Zeichenvorganges.',
	// 	type: 'checkbox'
	// };

	// Force-Length
	//  controls[controls.length] = {
	// 	label: 'Kantenlänge fixieren',
	// 	name: 'digitize_forceedgelength',
	// 	tooltip: 'Fixiert die Kantenlänge während des Zeichenvorganges.',
	// 	type: 'checkbox'
	// };

	// Freehand-Checkbox
	controls[controls.length] = {
		label: 'Freihand zeichnen',
		name: 'digitize_freehand',
		tooltip: 'Schaltet das Freihandzeichen ein oder aus.',
		type: 'checkbox',
		change: function (evt, form, control) {
			self._onFreehandChanged(form.getValue('digitize_freehand'));
		}
	};

	var form_config = {
		controls: controls
		// validate: function(form, params) {},
		// submit: function(form, params) {},
		// error: function(form, err) {}
	};

	this.form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this.form.getElement());
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Nutzer das Freihandzeichnen über die Checkbox aktiviert.
 *
 * @method
 * @param {boolean} enabled
 * @protected
 */
gc.gis.module.GCDigitize.DrawPanel.prototype._onFreehandChanged = function(enabled)
{
	this._module.enableFreehand(enabled);
};